(function() {
    "use strict";

    document.querySelectorAll('.menu-drawer__menu-item-wrapper').forEach(wrapper => {
        const link = wrapper.querySelector('a.menu-drawer__menu-item');
        const details = wrapper.querySelector('details');

        if (link && details) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                details.hasAttribute('open')
                    ? details.removeAttribute('open')
                    : details.setAttribute('open', '');
            });
        }
    });

    /* write other functions here */

})();